<ng-container *ngIf="isPaymentOptionsEnabled; else cashOnly">
  <div class="payment-method-wrapper">
    <app-payment-method 
      [google]="google"
      [kind]="flow"
      [isSdfCardFlow]="true"
      [labels]="labels"
      [selectedPaymentMethod]="selectedPaymentMethod"
      [serviceOptions]="serviceOptions"
      [isLocationSelected]="(isLocationSelected$ | async)"
    ></app-payment-method>
  </div>
</ng-container>
<ng-template #cashOnly>
  <div class="payment-method-wrapper">
    <div class="payment-method-container">
      <div class="payment-method-body">
        <div class="payment-method-label-container">
          <span
            class="text-label"
            *ngIf="flow === 'deposit'; else recieveMethodLabel"
          >
            {{ sdfCardLabels?.landingPage?.payment?.payMethod }}
          </span>
          <ng-template #recieveMethodLabel>
            <span class="text-label">
              {{ sdfCardLabels?.landingPage?.payment?.receiveMethod }}
            </span>
          </ng-template>
        </div>
        <div class="cash-at-location-label-container">
          <span
            class="text-label"
            *ngIf="flow === 'deposit'; else pickUpLocation"
          >
            {{ sdfCardLabels?.landingPage?.payment?.cashLocation }}
          </span>
          <ng-template #pickUpLocation>
            <span class="text-label">
              {{ sdfCardLabels?.landingPage?.payment?.cashPickUp }}
            </span>
          </ng-template>
        </div>
      </div>
      <div
        *ngIf="(isLocationSelected$ | async) === false"
        class="select-location-section"
      >
        <app-moneygram-locations-link
          [google]="google"
          [kind]="flow"
          [isSdfCardFlow]="true"
          [labels]="labels"
          [enableSelectLocationBtn]="enableSelectLocationBtn"
        ></app-moneygram-locations-link>
      </div>
    </div>
  </div>
  <div
    class="notification-wrapper"
    *ngIf="
      isNotificationContainerOpen && (isLocationSelected$ | async) === false
    "
    [@fadeOut]
  >
    <div class="notification-contant-container">
      <div class="notification-content">
        <div class="info-icon-container">
          <img
            src="assets\images\master-notification.svg"
            alt="info-icon"
            class="info-icon"
          />
        </div>
        <p
          class="content-body"
          *ngIf="flow === 'deposit'; else cashOutlocationFeesInfo"
        >
          {{ sdfCardLabels?.landingPage?.payment?.cashInlocationFeesInfo }}
        </p>
        <ng-template #cashOutlocationFeesInfo>
          <p class="content-body">
            {{ sdfCardLabels?.landingPage?.payment?.cashOutlocationFeesInfo }}
          </p>
        </ng-template>
        <div
          class="close-icon-container"
          (click)="isNotificationContainerOpen = false"
        >
          <img src="assets\images\close-icon.svg" alt="" class="close-icon" />
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="isLocationSelected$ | async">
  <div class="selected-location-wrapper">
    <div class="selected-location-container">
      <div class="location-body">
        <div class="selected-location-label-container">
          <span class="location-label-text">
            {{ sdfCardLabels?.landingPage?.payment?.location }}.
          </span>
        </div>
        <div class="selected-location-details">
          <div class="location-name-container">
            <span class="text-label">
              {{ (selectedLocation$ | async)?.locationDetails?.name }}
            </span>
          </div>
          <div class="location-address-container">
            <span class="address">
              {{
                locationFinderService.getFormattedAddress({
                  addressLine1: (selectedLocation$ | async)?.locationDetails
                    ?.addressLine1,
                  addressLine2: (selectedLocation$ | async)?.locationDetails
                    ?.addressLine2,
                  addressLine3: (selectedLocation$ | async)?.locationDetails
                    ?.addressLine3
                })
              }}
            </span>
            <span class="city-state-and-zip">
              {{
                locationFinderService.getFormattedAddress({
                  city: (selectedLocation$ | async)?.locationDetails?.city,
                  state: (selectedLocation$ | async)?.locationDetails?.state,
                  zipCode: (selectedLocation$ | async)?.locationDetails
                    ?.zipCode,
                  postalCode: (selectedLocation$ | async)?.locationDetails
                    ?.postalCode
                })
              }}
            </span>
          </div>
        </div>
      </div>
      <div class="place-holder-div"></div>
      <div class="select-location-section">
        <app-moneygram-locations-link
          [google]="google"
          [kind]="flow"
          [isSdfCardFlow]="true"
          [labels]="labels"
        ></app-moneygram-locations-link>
      </div>
    </div>
  </div>
</ng-container>
